import React, { useEffect, useState } from "react";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { DataTable } from "primereact/datatable";
import moment from "moment";
import { Column } from "primereact/column";
import Spinner from "../../components/spinner";
import useDebounce from "../../components/hooks/useDebounce";
import { axiosApi } from "../../../services/axios_api";
import PaginatorComponent from "../../components/paginator";
import { toast } from "react-toastify";
import { exportToExcel, renderTextWithTooltip } from "../../components/helper";
import EditAddForm from "./edit-add-form";
import editIcon from "../../../../assets/assests/edit.png";
import { confirmDialog } from "primereact/confirmdialog";
import deleteIcon from "../../../../assets/assests/delete.png";
import Dots from "../../../../assets/assests/detail.png";
import Details from "./details-auto";
const AutoLogoutSetting = ({
  globalFilter,
  selectedData,
  isEdit,
  showDialog,
  setShowDialog,
  exportCSV,
  setIsEdit,
  fromDate,
  toDate,
}) => {
  const [loading, setLoading] = useState(false);
  const [filteredList, setFilteredList] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(10);
  const [editable, setEditable] = useState();
  const [rowselect, setRowselect] = useState(null);
  const [res, setRes] = useState([]);
  const [showdetail, setShowdetail] = useState(false);
  const debouncedSearch = useDebounce(globalFilter, 500);

  const getLogoutsData = async (pageNumber = 1, pageSize = rows) => {
    setLoading(true);
    try {
      const response = await axiosApi.get(
        `/Portal/auto-logout-settings/get-all-paginated`,
        {
          params: {
            pageNumber,
            pageSize,
            searchTerm: debouncedSearch || "",
            fromDate: fromDate ? moment(fromDate).format("YYYY-MM-DD") : null,
            toDate: toDate ? moment(toDate).format("YYYY-MM-DD") : null,
          },
        }
      );
      setFilteredList(response.data.body);
      setTotalRecords(response.data.totalRecords);
    } catch (error) {
      toast.error("Failed to fetch data.");
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = (event) => {
    const { first, rows } = event;
    setFirst(first);
    setRows(rows);
    const pageNumber = first / rows + 1;
    getLogoutsData(pageNumber, rows);
  };

  useEffect(() => {
    getLogoutsData();
  }, [debouncedSearch, fromDate, toDate]);

  const onHide = () => {
    setShowDialog(false);
  };
  const editAction = (rowData) => {
    setEditable(true);
    setIsEdit(true);
    setRowselect(rowData);
    setShowDialog(true);
  };
  const showDetails = (rowData) => {
    setRowselect(rowData);
    setShowdetail(true);
  }
  const actionTemplate = (rowData) => {
    return (
      <div className="action-buttons">
        <Button
          className=" p-button-edit p-0 mr-3"
          onClick={() => {
            editAction(rowData);
          }}
          aria-label="Edit"
        >
          <img src={editIcon} alt="Edit" />
        </Button>

        <Button
          className=" p-button-edit p-0 mr-3"
          onClick={() => {
            confirm(rowData);
          }}
        >
          <img src={deleteIcon} alt="Delete" />
        </Button>
        <Button className="p-button-edit p-0 mr-3" onClick={() => showDetails(rowData)}>
          <img src={Dots} alt="Details" />
        </Button>
      </div>
    );
  };

  const exportCSVHandler = async () => {
    setLoading(true);
    try {
      const response = await axiosApi.get(
        `/Portal/auto-logout-settings/get-all`
      );
      exportToExcel(response.data.body, columnsData, "AutoLogoutData");
    } catch (error) {
      toast.error("Failed to export data.");
      console.error("Export Error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (exportCSV) {
      exportCSV.current = exportCSVHandler;
    }
  }, []);

  const accept = async (rowData) => {
    try {
      const response = await axiosApi.delete(
        `/Portal/auto-logout-settings/delete?id=${rowData.id}`
      );

      setRes(response.data);
      toast.success("Deleted Successfully");
      getLogoutsData();
      onHide();
    } catch (error) {
      toast.error("Failed to delete. Please try again.");
      console.error("Error deleting disclaimer:", error);
    }
  };

  const reject = () => {};

  const confirm = (rowData) => {
    confirmDialog({
      message: "Are you sure you want to delete ?",
      header: "Delete Confirmation",
      icon: "pi pi-info-circle",
      accept: () => accept(rowData),
      reject: () => reject(),
      acceptClassName: "custom-btn-red",
      rejectClassName: "custom-white-red",
      className: "center-buttons no-close-button",
    });
  };

  const columnsData = [
    // {
    //   field: "kioskId",
    //   header: "Setting ID",
    //   body: (rowData) => rowData.kioskId || "--",
    // },
    {
      field: "kioskName",
      header: "kiosk Name",
      body: (rowData) => renderTextWithTooltip(rowData, "kioskName", "bottom"),
    },
    {
      field: "featureName",
      header: "feature Name",
      body: (rowData) => rowData.featureName || "--",
    },
    {
      field: "durationMinutes",
      header: "duration (MIN)",
      body: (rowData) => rowData.durationMinutes || "--",
    },

    {
      field: "modifiedDate",
      header: "Date",
      body: (rowData) =>
        rowData.modifiedDate
          ? moment(rowData.modifiedDate).format("YYYY-MM-DD HH:mm:ss")
          : "--",
    },
    {
      header: "Action",
      body: actionTemplate,
    },
  ];

  return (
    <>
      <Dialog
        visible={showdetail}
        onHide={() => setShowdetail(false)}
        header="Auto Log Details"
       className="dialog-size"
      >
        <Details
                  rowData={ rowselect } />
      </Dialog>
      <Dialog
        header={
          <div className="popup-header">
            <div className="popup-header-text">
              {isEdit ? "Edit logout Setting" : "Add logout Setting"}
            </div>
          </div>
        }
        visible={showDialog}
        onHide={onHide}
        className="dialog-size"
      >
        <EditAddForm
          rowData={isEdit ? rowselect : null}
          setShowDialog={setShowDialog}
          getLogoutsData={getLogoutsData}
          showDialog={showDialog}
          editable={editable}
          onHide={onHide}
          formData={isEdit ? selectedData : null}
          setRes={setRes}
        />
      </Dialog>

      {loading && (
        <div className="spinner-overlay">
          <Spinner />
        </div>
      )}

      <div className="card card-container">
        <DataTable
          emptyMessage="No record found."
          value={filteredList}
          className="custom-data-table"
          scrollable
          globalFilter={globalFilter}
        >
          {columnsData.map((data, index) => (
            <Column
              key={index}
              field={data.field}
              header={data.header}
              body={data.body}
              frozen={data.frozen}
            />
          ))}
        </DataTable>
        {totalRecords > 0 && (
          <PaginatorComponent
            first={first}
            rows={rows}
            totalRecords={totalRecords}
            onPageChange={handlePageChange}
          />
        )}
      </div>
    </>
  );
};

export default AutoLogoutSetting;
